export default __webpack_public_path__ + "static/media/icon_hamburger_menu.7ebe2d29.svg";